
import { IconBase } from './IconBase'
import type { IconProps } from './IconBase'

export const IconTheme = (props: IconProps) => (
  <IconBase {...props}>
    <svg width="48" height="48" viewBox="16 18 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6095_15911)">
        <path d="M24.0007 30.6673C27.6825 30.6673 30.6673 27.6825 30.6673 24.0007C30.6673 20.3188 27.6825 17.334 24.0007 17.334C20.3188 17.334 17.334 20.3188 17.334 24.0007C17.334 27.6825 20.3188 30.6673 24.0007 30.6673Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M26.6673 21.6673C26.6673 24.4287 24.4287 26.6673 21.6673 26.6673C21.2575 26.6673 20.8593 26.618 20.4781 26.525C21.2646 27.6205 22.5493 28.334 24.0007 28.334C26.3939 28.334 28.334 26.3939 28.334 24.0007C28.334 22.5493 27.6205 21.2646 26.525 20.4781C26.618 20.8593 26.6673 21.2575 26.6673 21.6673Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_6095_15911">
          <rect width="16" height="16" fill="white" transform="translate(16 16)"/>
        </clipPath>
      </defs>
    </svg>
  </IconBase>
)
